/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-12-05 09:40:53
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    IUITagMoreTagsUnit,
    UITag,
    IUIRelationPair,
    EUITagRuleUnion,
} from "@root/core/tags";

// uicSummary provide custom rule for "summary" for "audit".
@UITag.set()
export class uicSummary extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean];
    allowNullRule: boolean = true;

    parse(input: IUITagInput): IUITagResult | null {
        let rule = this.parseRule(input) ?? true;
        if (rule == false) return null;

        let moreTags: IUITagMoreTagsUnit[] = [
            {
                tag: "uiLabel",
                rule: "提交審核備註",
            },
            {
                tag: "uiDescription",
                rule: "請提供完整的資料，以便利審核員的處理",
            },
            {
                tag: "uiType",
                rule: "iv-form-textarea",
            },
            {
                tag: "uiSubmitWrap",
                rule: "input",
            },
            {
                tag: "uiValidator",
                rule: (o) =>
                    (o.value?.length ?? 0) < 2
                        ? { state: false, message: "審核備註長度需大於 2 個字元" }
                        : undefined,
            },
            {
                tag: "uiHidden",
                rule: (o) =>
                    o.row.summaryOptions === undefined || o.row.summaryOptions === 1
                        ? false
                        : true,
            },
            {
                tag: "uiRequired",
                rule: (o) =>
                    o.row.summaryOptions === undefined
                        ? null
                        : o.row.summaryOptions === 1
                          ? true
                          : false,
            },
            {
                tag: "uiAttrs",
                rule: { height: "100px" },
            },
            {
                tag: "uiMeta",
                rule: { detail: false },
            },
        ];

        return {
            specials: {
                moreTags,
            },
        };
    }
}
